import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import Rutas from 'src/app/Models/Base/rutas';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { TourController } from 'src/assets/js/Tour/Tour';
import { getLocalStorage, titleCase } from 'npx-arc-ui/utils';
import { ModalListaEmpresasComponent } from '../modal-lista-empresas/modal-lista-empresas.component';
import { Observable } from 'rxjs';
import { tap, shareReplay, take } from 'rxjs/operators';
import Storage from 'src/app/Models/Base/storage';
import { GetUserCompanyInfoResult } from 'src/app/Models/Company/get-user-company-info-result';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ContenedorBannerComponent } from '../contenedor-banner/contenedor-banner.component';
import GetAccessOnboardingCompanyResult from 'src/app/Models/Company/get-access-onboarding-result';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: true,
  imports: [
    CommonModule
    , MatIconModule
    , MatTooltipModule
    , MatMenuModule
    , RouterModule
    , NgxSkeletonLoaderModule
    , ContenedorBannerComponent
  ]
})
export class MainComponent {
  dashboard = Rutas.DASHBOARD;
  keywordDashCompany: string = "";
  keywordDash: string = "";
  private searchTime = 0;
  public tour: TourController;
  _menu: Array<{ title: string, on: () => void, hiden?: boolean }> = [
    { title: 'Cambiar empresa', on: () => this.openCompaniesModal(), hiden: !this.isMobile },
    { title: 'Mis datos', on: () => this.appState.router.navigateByUrl(Rutas.MY_ACCOUNT) },
    { title: 'Mis Empresas', on: () => this.appState.router.navigateByUrl(Rutas.MY_COMPANIES) },
    { title: 'Autenticación en dos pasos', on: () => this.appState.router.navigateByUrl(Rutas.DOUBLE_FACTOR_LIST) },
    { title: 'Cambio de contraseña', on: () => this.appState.router.navigateByUrl(Rutas.CHANGE_PASSWORD) },
    // { title: 'Administración de usuarios', on: () => this.appState.router.navigateByUrl(Rutas.ADMINISTRATION), hiden: true },
    { title: 'Configuraciones', on: () => this.appState.router.navigateByUrl(Rutas.PRODUCT_ACCESS), hiden: true },
    { title: 'Cerrar Sesion', on: () => this.appState.onLogOut() },

  ]
  userCompany$: Observable<GetUserCompanyInfoResult>;
  obtenerInformacionOnboarding$: Observable<GetAccessOnboardingCompanyResult>;
  public SecretLogin: boolean = false;
  constructor(
    public appState: AppStateService
    , private route: ActivatedRoute
  ) {
    this.SecretLogin = getLocalStorage(Storage.SUPPORT_LOGIN)?.data === '1';

    this.tour = new TourController();

    this.userCompany$ = this.appState.CompanyServices
      .GetUserCompanyInfo()
      .pipe(
        tap(({ isAdmin, expirationDate, showAdminBanner, hasSubscription }) => {
          // this._menu.find(({title}) => title.includes('Administración de usuarios'))!.hiden = !isAdmin;
          this._menu.find(({ title }) => title.includes('Configuraciones'))!.hiden = !isAdmin;
          this._menu.find(({ title }) => title.includes('Mis datos'))!.hiden = this.SecretLogin;
          this._menu.find(({ title }) => title.includes('Autenticación en dos pasos'))!.hiden = this.SecretLogin;
          this._menu.find(({ title }) => title.includes('Cambio de contraseña'))!.hiden = this.SecretLogin;
          this._menu.find(({ title }) => title.includes('Configuraciones'))!.hiden = this.SecretLogin;
          this._menu.find(({ title }) => title.includes('Cambiar empresa'))!.hiden = this.appState.OneCompany || !this.isMobile;
          //Se valida el dia de expiracion con fecha actual
          const fechaExpiracion = expirationDate && expirationDate || '';
          this.appState.ExpirationBanner = !hasSubscription && ((showAdminBanner && isAdmin) || !showAdminBanner) ? fechaExpiracion : '';
        })
        // shareReplay(1) comparte la respuesta HTTP entre las múltiples suscripciones del template (async pipe),
        // evitando que se duplique la llamada al endpoint por cada | async en el HTML.
        , shareReplay(1)
      )

    this.obtenerInformacionOnboarding$ = this.appState.CompanyServices.GetCompanyAccessOnboarding();
  }

  get hiden(): boolean {
    return window.location.pathname.toLowerCase().includes(Rutas.DASHBOARD)
  }

  get isUserInfo(): boolean {
    return this.appState.router.url.split('?')[0].toLowerCase() === '/' + Rutas.MY_ACCOUNT.toLowerCase();
  }

  get isCompanies(): boolean {
    return this.appState.router.url.split('?')[0].toLowerCase() === '/' + Rutas.MY_COMPANIES.toLowerCase();
  }

  get isTwoFactor(): boolean {
    return this.appState.router.url.split('?')[0].toLowerCase() === '/' + Rutas.DOUBLE_FACTOR_LIST.toLowerCase();
  }

  get isPasswordChange(): boolean {
    return this.appState.router.url.split('?')[0].toLowerCase() === '/' + Rutas.CHANGE_PASSWORD.toLowerCase();
  }

  get isSettings(): boolean {
    return this.appState.router.url.split('?')[0].toLowerCase() === '/' + Rutas.PRODUCT_ACCESS.toLowerCase();
  }

  get breadcrumbs(): Array<string> {
    try {
      const
        parent = this.route.snapshot.data?.breadcrumbs ?? [],
        childen = this.route.snapshot.children[this.route.snapshot.children.length - 1].data?.breadcrumbs || this.route.snapshot.children[this.route.snapshot.children.length - 1].firstChild?.data?.breadcrumbs || [];
      return [...parent, ...childen].map(c => titleCase(c));
    } catch (error) {
      return []
    }
  }

  get renderBreadcrumb(): string {
    let breadcrumb = '';
    if (!this.breadcrumbs.length) return breadcrumb;
    for (let i = 0; i < this.breadcrumbs.length; i++) {
      if (i === (this.breadcrumbs.length - 1)) {
        breadcrumb += `<strong class="--child">${this.breadcrumbs[i]}</strong>`
      }
      else breadcrumb += `<legend> ${this.breadcrumbs[i]} </legend> <span class="material-icons --icon" style=\"text-decoration: none;\">chevron_right</span>`;
    }
    return breadcrumb;
  }

  get isMobile(): boolean {
    return this.appState?.isMobile
  }

  get CompanyName() {
    return this.appState.CompanyName
  }

  get Email() {
    return this.appState.Email
  }

  get productList() {
    return this.appState.SearchProductByCompanie && this.appState.SearchProductByCompanie.productList || []
  }

  selectProductDash(code: string, isPublic: boolean, name: string) {

    this.appState.ProductService.setErpLogin(code, isPublic, name)
  }

  getProductDash() {
    this.appState.ProductService.searchProducts(this.keywordDash);
  }

  starTimer() {
    this.searchTime = Date.now(); //momento en que se modifica el texto de búsqueda (variable global)
    let mySearchTime = this.searchTime; //momento en que se modifica el texto (variable local)
    setTimeout(() => {
      if (mySearchTime == this.searchTime) { //Si el valor local es igual al global, no se presionó otra tecla después de nosotros
        this.appState.ProductService.searchProducts(this.keywordDash);
      }
    }, 1000)
  }


  openCompaniesModal() {
    if (this.appState.OneCompany) return;

    this.appState.dialog.open(ModalListaEmpresasComponent, {
      maxWidth: '95%',
      maxHeight: '95%',
      width: '591px',
      height: '670px'
    })
  }

  refresh() {
    this.appState.router.navigateByUrl('');
  }

  onPagarEnLinea(): void {
    this.appState.ProductService.GetProductsByCompanyAndUser()
      .pipe(take(1))
      .subscribe(res => {
        if (res.success) {
          const miCuenta = res.productList?.find(p => p.name === 'Mi Cuenta');
          if (miCuenta) {
            this.appState.onSelectProduct(miCuenta.code, miCuenta.isPublic, miCuenta.name);
          }
        }
      });
  }
}
